import authConfig from '@/assets/bearerConfig';
import axios from "axios";

export default async function sendStartObamacareFlow(contactResponse) {
  try {
    const formatedData = {
      "zoho_id": contactResponse.id,
      "fullname": contactResponse.full_name,
      "email": contactResponse.email,
      "mobile": contactResponse.mobile,
      "id_pipeone": contactResponse.pipeone_id
    }

    const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/flow/start`, formatedData, authConfig());
    console.log(response);
    return response;

  } catch (error) {
    return error;
  }
}